import React, { useState } from "react";

// Dummy data
const initialMentors = [
  {
    id: 1,
    name: "Alice Johnson",
    mentees: [
      { id: 101, name: "Bob Smith", approved: false },
      { id: 102, name: "Charlie Lee", approved: true },
    ],
  },
  {
    id: 2,
    name: "David Kim",
    mentees: [
      { id: 103, name: "Eva Brown", approved: false },
      { id: 104, name: "Frank White", approved: false },
    ],
  },
  {
    id: 3,
    name: "Priya Patel",
    mentees: [],
  },
];

// Mentee lookup for scalable rendering
const getMenteeMentorMap = (mentors) => {
  const menteeMap = {};
  mentors.forEach((mentor) => {
    mentor.mentees.forEach((mentee) => {
      menteeMap[mentee.id] = mentor.name;
    });
  });
  return menteeMap;
};

const MentorMenteeProgram = () => {
  const [mentors, setMentors] = useState(initialMentors);

  const handleApprove = (mentorId, menteeId) => {
    setMentors((prevMentors) =>
      prevMentors.map((mentor) =>
        mentor.id === mentorId
          ? {
              ...mentor,
              mentees: mentor.mentees.map((mentee) =>
                mentee.id === menteeId
                  ? { ...mentee, approved: true }
                  : mentee
              ),
            }
          : mentor
      )
    );
  };

  // For scalable lookup
  const menteeMentorMap = getMenteeMentorMap(mentors);
  const allMentees = mentors.flatMap((mentor) =>
    mentor.mentees.map((mentee) => ({
      ...mentee,
      mentorName: mentor.name,
      mentorId: mentor.id,
    }))
  );

  return (
    <div className="max-w-4xl mx-auto py-8">
      <h1 className="text-2xl font-bold mb-6 text-center">Mentor-Mentee Program</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Mentor Cards */}
        {mentors.map((mentor) => (
          <div key={mentor.id} className="border rounded-lg p-4 bg-white shadow">
            <h2 className="text-xl font-semibold mb-2 text-blue-700">{mentor.name}</h2>
            <h3 className="text-md font-medium mb-2">Mentees:</h3>
            {mentor.mentees.length === 0 ? (
              <div className="text-gray-500 italic mb-2">No mentees assigned.</div>
            ) : (
              <ul>
                {mentor.mentees.map((mentee) => (
                  <li
                    key={mentee.id}
                    className="flex items-center justify-between py-2 border-b last:border-b-0"
                  >
                    <span>
                      {mentee.name}
                      {mentee.approved ? (
                        <span className="text-green-600 font-semibold ml-2">Approved</span>
                      ) : (
                        <span className="text-yellow-600 font-semibold ml-2">Pending</span>
                      )}
                    </span>
                    {!mentee.approved && (
                      <button
                        onClick={() => handleApprove(mentor.id, mentee.id)}
                        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                      >
                        Approve
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      <div className="mt-10">
        <h2 className="text-xl font-bold mb-4 text-center">All Mentees & Their Mentors</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded shadow">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left">Mentee</th>
                <th className="py-2 px-4 border-b text-left">Mentor</th>
                <th className="py-2 px-4 border-b text-left">Status</th>
                <th className="py-2 px-4 border-b"></th>
              </tr>
            </thead>
            <tbody>
              {allMentees.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-4 text-gray-500">
                    No mentees in the program.
                  </td>
                </tr>
              ) : (
                allMentees.map((mentee) => (
                  <tr key={mentee.id}>
                    <td className="py-2 px-4 border-b">{mentee.name}</td>
                    <td className="py-2 px-4 border-b">{mentee.mentorName}</td>
                    <td className="py-2 px-4 border-b">
                      {mentee.approved ? (
                        <span className="text-green-600 font-semibold">Approved</span>
                      ) : (
                        <span className="text-yellow-600 font-semibold">Pending</span>
                      )}
                    </td>
                    <td className="py-2 px-4 border-b">
                      {!mentee.approved && (
                        <button
                          onClick={() => handleApprove(mentee.mentorId, mentee.id)}
                          className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                        >
                          Approve
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MentorMenteeProgram;